import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["mode", "policyPicker", "explicitPeople"]

  connect() {
    this.policyPickerElement?.addEventListener("workflow-input-select:change", this.updateExplicitPeople)
    this.update()
    requestAnimationFrame(() => this.update())
  }

  disconnect() {
    this.policyPickerElement?.removeEventListener("workflow-input-select:change", this.updateExplicitPeople)
  }

  update() {
    const picker = this.policyPickerController
    if (picker) {
      picker.filterModeValue = this.modeTarget.value
    }
    this.updateExplicitPeople()
  }

  updateExplicitPeople = () => {
    const picker = this.policyPickerController
    const selected = picker?.selectedValue || []
    this.toggle(this.explicitPeopleTarget, selected.some((option) => option.id === "explicit_people"))
  }

  toggle(element, visible) {
    element.classList.toggle("hidden", !visible)
    element.hidden = !visible
  }

  get policyPickerElement() {
    return this.policyPickerTarget.querySelector("[data-controller~='workflow-input-select']")
  }

  get policyPickerController() {
    const element = this.policyPickerElement
    if (!element) return null

    return this.application.getControllerForElementAndIdentifier(element, "workflow-input-select")
  }
}
